import { Component, OnInit } from '@angular/core';
import {
  MeteringPointCalculationParameterDto,
  MeteringPointDisassociateMeterDto,
  MeteringPointDto,
  MeteringPointService,
  MeteringPointSubType,
  MeterQueryResultDto
} from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';
import { CalculationFormComponent } from '@views/calculation/calculation-form/calculation-form.component';

@Component({
  selector: 'app-stop-meter-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    SelectDirective,
    TranslatePipe,
    InputDateDirective,
    CalculationFormComponent
  ],
  templateUrl: './stop-meter-modal.component.html',
  styleUrl: './stop-meter-modal.component.css'
})
export class StopMeterModalComponent implements OnInit {
  /** Form **/
  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    meterIdentification: new FormControl(null, Validators.required),
    meterNumber: new FormControl(null, Validators.required),
    subType: new FormControl(null, Validators.required),
    validFrom: new FormControl(null, [Validators.required]),
    meteringPointCalculationStructure: new FormControl(null),
    endMeterStand: new FormControl(null),

    calculationStructureInternalName: new FormControl(),
  });

  /** Meter Data **/
  public meterQuery?: MeterQueryResultDto;

  /** ID **/
  public id?: string;

  /** Meteringpoint **/
  public meteringPoint?: MeteringPointDto;

  /** Row Handler **/
  public rowHandler: MeteringPointCalculationParameterDto[] = [];

  /** Subtype **/
  public meterSubType = enumToKeyValue(MeteringPointSubType, { omitKeys: ['NotSpecified', 'Physical'], prefixValue: 'enum.meteringpoint.meteringpointsubtype.' });

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointService: MeteringPointService,
  ) {


    /** Change Validation Rules **/
    this.form.get('subType')?.valueChanges.subscribe(value => {
      if (value === MeteringPointSubType.Virtual) {
        this.form.get('meteringPointCalculationStructure')?.enable();
      } else {
        this.form.get('meteringPointCalculationStructure')?.disable();
      }
    });
  }

  public ngOnInit(): void {
    if (this.meteringPoint) {
      this.form.get('meteringPointIdentification')?.setValue(this.meteringPoint.identification);
    }
    if (this.meterQuery) {
      this.form.get('meterIdentification')?.setValue(this.meterQuery.id)
      this.form.get('meterNumber')?.setValue(this.meterQuery.meterNumber);
    }

    if (this.meteringPoint) {
      this.form.get('subType')?.setValue(this.meteringPoint.detailCharacteristics?.subType);
    }
  }

  public submit(): void {
    this.form.get('meteringPointIdentification')?.setValue(this.id);

    /** Form ApiService **/
    this.formApiService.submit<MeteringPointDisassociateMeterDto>(
      this.form,
      (data) => this.meteringPointService.meteringPointDisassociateMeterPost(data),
      {
        preprocess: (data) => {
          return {
            ...data,
            meteringPointCalculationStructure: data.subType === MeteringPointSubType.Virtual ? {
              calculationStructureInternalName: data.calculationStructureInternalName,
              parameters: this.rowHandler,
              meteringPointIdentification: data.meteringPointIdentification,
              validFrom: data.validFrom,
            } : null,
          };
        },
        successMessage: 'meteringpoint.meter.stop.success',
        closeModal: true
      },
    );
  }
}
